import { jsx, jsxs } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { isDev } from "../../../base/index.js";
import { ErrorBoundary } from "../../../react-error-boundary/index.js";
import { createEmptyFormState } from "./createEmptyFormState.js";
const formContext = createContext(createEmptyFormState());
function Fallback(props) {
  const { error, resetErrorBoundary } = props;
  return /* @__PURE__ */ jsxs("div", { role: "alert", children: [
    /* @__PURE__ */ jsx("p", { children: "[FormRoot] Something went wrong:" }),
    /* @__PURE__ */ jsx("pre", { style: { color: "red" }, children: error.message })
  ] });
}
function FormRoot(props) {
  const { children, formState, ...errorBoundaryProps } = props;
  return /* @__PURE__ */ jsx(ErrorBoundary, { FallbackComponent: Fallback, ...errorBoundaryProps, children: /* @__PURE__ */ jsx(formContext.Provider, { value: formState, children }) });
}
function useFormInternalContext() {
  const ctx = useContext(formContext);
  if (isDev() && ctx.store.id === "_____defaultEmptyState_____") {
    throw new Error(`You cannot use a FormState Context without mounting a FormRoot component as an ancestor.`);
  }
  return ctx;
}
export {
  FormRoot,
  useFormInternalContext
};
//# sourceMappingURL=formContext.js.map
